import Input from "../atoms/input.atom"
import React from "react"
import Button from "../atoms/button.atom"
import * as yup from "yup"
import { validateYup } from "../template-info/templateUtils"
import { axiosInstance } from "../../lib/axios"
import { EndpointConfig, RoutesConfig } from "../../config"
import { toast } from "react-toastify"
import { authenticate } from "../../helper/auth"
import { useNavigate } from "react-router-dom"

import "./bootstrap.min.css"
import "./style.css"

function UserLogin() {
	const [form, setForm] = React.useState({
		email: "",
		password: ""
	})

	const [displayPassword, setDisplayPassword] = React.useState("")
	const [loading, setLoading] = React.useState(false)
	const [errors, setErrors] = React.useState({})

	const navigation = useNavigate()

	

	const handlePasswordChange = (e) => {
		const value = e.target.value
		const prevLength = displayPassword.length
		const newLength = value.length
		if (newLength > prevLength) {
			// New character added
			const newChar = value.slice(prevLength)
			setForm({ ...form, password: form.password + newChar })
			setDisplayPassword('•'.repeat(newLength))
		} else if (newLength < prevLength) {
			// Character deleted (backspace)
			const newPassword = form.password.slice(0, newLength)
			setForm({ ...form, password: newPassword })
			setDisplayPassword('•'.repeat(newLength))
		}
		// If length same, ignore (for now)
	}

	const login = () => {
		let schema = yup.object().shape({
			email: yup.string().trim().required("Required"),
			password: yup.string().trim().min(1).required("Required")
		})
		validateYup(schema, form)
			.then(() => {
				setLoading(true)
				;(async () => {
					const response = await axiosInstance.post(
						EndpointConfig.Login,
						{
							email: form.email,
							password: btoa(form.password)
						},
						{
							withCredentials: true
						}
					)

					authenticate(response, () => {
						const role = response.data.user.role
						const redirect = response.data.redirect

						if (role === "Admin") {
							navigation(RoutesConfig.Admin)
						} else {
							navigation(redirect)
						}
					})
				})()
					.catch((error) => {
						console.error(error)

						if (error?.response?.data?.error) {
							toast(error.response.data.error)
						} else {
							toast("Something went wrong")
						}
					})

					.finally(() => setLoading(false))
			})
			.catch(setErrors)
	}

	return (
		<div className="login-page">
			<div className="container-fluid full-height">
				<div className="row row-height">
					<div className="col-lg-6 content-left">
						<div className="content-left-wrapper">
							<a href="https://www.vfirst.com/" target="_blank" id="logo">
								<img src="/logo.png" alt="" />
							</a>
							<div>
								<figure>
									<img src="/main-left.webp" alt="" className="img-fluid round" />
								</figure>
								<h2>Customer Engagement with Conversations</h2>
								<a
									href="https://www.vfirst.com/integrations"
									target="_blank"
									className="rounded btn_1"
								>
									Explore More
								</a>
							</div>
							<div className="copy">
								Copyright © 2024{" "}
								<a href="#" className="link-inv">
									ValueFirst
								</a>
							</div>
						</div>
					</div>

					<div className="col-lg-6 content-right">
						<div id="wizard_container">
							<div id="middle-wizard">
								<div className="step">
									{errors?.email?.message && (
										<p className="err">Email {errors?.email?.message}</p>
									)}

									{errors?.password?.message && (
										<p className="err">Password {errors?.password?.message}</p>
									)}

									<h3>Log In</h3>
									<p>* indicates a required field</p>
									<form autoComplete="off" data-form-type="other">
									<div  className="form-group">
										<input
										
										autoComplete="off"
										
											type="text"
											name="email_field_custom"
											className="form-control"
											placeholder="Your Email*"
											
											value={form.email}
											onChange={(e) =>
												setForm({ ...form, email: e.target.value })
											}
											required
										/>
									</div>
									<div className="form-group">
										<input
											type="text"
											autoComplete="off"
										
											name="password_field_custom"
											className="form-control"
											placeholder="Password*"
											
											value={displayPassword}
											onChange={handlePasswordChange}
											required
										/>
									</div>
									</form>
								</div>
							</div>
							<div id="bottom-wizard">
								{loading ? (
									<button className="forward" disabled>
										Loading
									</button>
								) : (
									<button type="submit" onClick={login} className="forward">
										Login
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default UserLogin
